import { render, staticRenderFns } from "./DailyStandUpDetails.vue?vue&type=template&id=490a14d7&scoped=true&"
import script from "./DailyStandUpDetails.vue?vue&type=script&lang=js&"
export * from "./DailyStandUpDetails.vue?vue&type=script&lang=js&"
import style0 from "./DailyStandUpDetails.vue?vue&type=style&index=0&id=490a14d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490a14d7",
  null
  
)

export default component.exports